@for (screen of screenList; track $index) {

    <div class="a-bg-light menuContainer" (click)="showScreen(screen)">
        <div class="a-font-12 a-py-4 a-px-4 font-weight-medium text-truncate">
            <span class="material-icons activeInactive" [ngClass]="{'active-screen': !!screen.isActive }">
                circle
            </span>
            <span>{{screen.label}}</span>
        </div>
    </div>

}